export const OfferDisplayStatusConst = {
    normal: "Normal",
	rerun: "Rerun",
	archive: "Archive"
}

export default OfferDisplayStatusConst;